module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/7iAqSq/tc-custom/9781613767214.jpg?1718043955863",
      "alt": "This image is the cover for the book Maria Baldwin's Worlds"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Maria Baldwin's Worlds\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“This well-written biography of an intriguing black educator is strong on narrative, recovering Baldwin’s life from obscurity with sound scholarship” (Jeffrey Aaron Snyder, author of "), _c('i', [_vm._v("Making Black History")]), _vm._v(").")]), _c('br'), _c('br'), _vm._v("In the late nineteenth century, Maria Baldwin established a unique place for herself as a highly respected educator at a largely white New England school. She also used her social standing to advance the African American cause. As an activist, she carried on the radical spirit of the Boston area’s renowned abolitionists. In "), _c('i', [_vm._v("Maria Baldwin’s Worlds")]), _vm._v(", Kathleen Weiler reveals both Baldwin’s victories and what fellow activist W. E. B. Du Bois called her “quiet courage” in everyday life, in the context of the wider black freedom struggle in New England."), _c('br'), _c('br'), _vm._v("African American sociologist Adelaide Cromwell called Baldwin “the lone symbol of Negro progress in education in the greater Boston area” during her lifetime. Baldwin fought alongside more radical activists like William Monroe Trotter for full citizenship for fellow members of the black community. And, in her professional and personal life, she negotiated and challenged dominant white ideas about black womanhood.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kathleen Weiler\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    University of Massachusetts Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0